module.exports = __webpack_public_path__ + "img/00_Fragezeichen.1ea9978d.svg";